import React from 'react';
import { useManagerStore } from '../../../lib/store-manager';
import { PersonnelDetail } from './PersonnelDetail';

export const ManagerPersonnel: React.FC = () => {
    const { personnel, isLoading, activePersonnel, setActivePersonnel } = useManagerStore();

    if (activePersonnel) {
        return <PersonnelDetail onBack={() => setActivePersonnel(null)} />;
    }

    return (
        <div className="manager-view">
            <div className="action-bar">
                <div>
                    <h1>Personel Listesi</h1>
                    <p className="subtitle">Kurumunuzdaki personellerin performansını inceleyin.</p>
                </div>
            </div>

            {isLoading && <div className="loading-spinner">Yükleniyor...</div>}

            <div className="grid-layout">
                {personnel.length === 0 && !isLoading && (
                    <div className="empty-state">Personel bulunamadı.</div>
                )}

                {personnel.map((p) => (
                    <div
                        key={p.id}
                        className="content-card personnel-card"
                        onClick={() => setActivePersonnel(p)}
                        style={{ cursor: 'pointer', borderLeft: '4px solid #10b981' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                            {p.avatar_url ? (
                                <img src={p.avatar_url} alt={p.full_name} style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }} />
                            ) : (
                                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280' }}>
                                    <span className="material-symbols-outlined">person</span>
                                </div>
                            )}
                            <div>
                                <h3 style={{ margin: 0 }}>{p.full_name}</h3>
                                <div style={{ fontSize: '13px', color: '#6b7280' }}>{p.email}</div>
                            </div>
                        </div>

                        <div className="user-role-badge" style={{ display: 'inline-block', padding: '4px 8px', borderRadius: '4px', background: '#f3f4f6', fontSize: '12px', color: '#4b5563', alignSelf: 'flex-start' }}>
                            {p.role.toUpperCase()}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
